module.exports = __webpack_public_path__ + "img/45_10.ede26a1b.png";